import React from "react";

import { TextField } from "@runwayhealth/runway-components-react";

interface IDatePickerProps {
  id: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  ariaLabel?: string;
}

const DatePicker = ({ id, onChange, value, ariaLabel }: IDatePickerProps) => {
  return (
    <>
      <TextField
        id={id}
        data-testid="date-text-input"
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        type="text"
        placeholder="MM/DD/YYYY"
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key !== "Backspace" && !/^\d*$/.test(e.key)) {
            e.preventDefault();
          }
          let input = e.currentTarget.value.replace(/\D/g, ""); // remove non-digits

          // Automatically insert slashes at the appropriate positions
          if (input.length > 2 && input.length <= 4) {
            input = input.slice(0, 2) + "/" + input.slice(2);
          } else if (input.length > 4) {
            input = input.slice(0, 2) + "/" + input.slice(2, 4) + "/" + input.slice(4, 8);
          }
          const month = parseInt(input.slice(0, 2), 10);
          const day = parseInt(input.slice(3, 5), 10);

          // Validate month and day
          if (e.key !== "Backspace") {
            if (month > 12) {
              e.preventDefault();
              return;
            }

            const daysInMonth = new Date(2020, month, 0).getDate(); // Using a leap year for February
            if (day > daysInMonth) {
              e.preventDefault();
              return;
            }
          }

          e.currentTarget.value = input;
        }}
        inputMode="numeric"
        required
      />
    </>
  );
};

export default DatePicker;
